// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import {
  Icon,
  Tabs,
  TabPane,
  Tag,
  Alert,
  Button,
  Row,
  Col,
  Breadcrumb,
  BreadcrumbItem,
  Form,
  FormItem,
  Input,
  Checkbox,
  Radio,
  DatePicker,
  Popover,
  Message,
  Card,
  Loading,
  MessageBox,
  Dialog,
  Select,
  Option,
  OptionGroup,
  Table,
  TableColumn,
  Cascader,
} from 'element-ui';
import App from './App'
import store from './store/index'
import router from './router'
import './assets/css/App.css'
import utils from "@/utils";

Vue.config.productionTip = false
Vue.use(Tabs);
Vue.use(TabPane);
Vue.use(Icon);
Vue.use(Tag);
Vue.use(Alert);
Vue.use(Button);
Vue.use(Row);
Vue.use(Col);
Vue.use(Breadcrumb);
Vue.use(BreadcrumbItem);
Vue.use(Form);
Vue.use(FormItem);
Vue.use(Input);
Vue.use(Checkbox);
Vue.use(Radio);
Vue.use(Dialog);
Vue.use(DatePicker);
Vue.use(Popover);
Vue.use(Card);
Vue.use(Select);
Vue.use(Option);
Vue.use(OptionGroup);
Vue.use(Table);
Vue.use(TableColumn);
Vue.use(Cascader);
Vue.use(Loading.directive);
Vue.prototype.$loading = Loading.service;
Vue.prototype.$message = Message;
Vue.prototype.$msgbox = MessageBox;
Vue.prototype.$alert = MessageBox.alert;
Vue.prototype.$confirm = MessageBox.confirm;
Vue.prototype.$prompt = MessageBox.prompt;

router.beforeEach((to, from, next) => {
  
  window.document.title = to.meta.title;
  if (to.path) {
    window._hmt = window._hmt || []
    window._hmt.push(['_trackPageview', '/#' + to.fullPath])
    if (window._czc) {
      var location = window.location
      var content_url = location.pathname + location.hash
      var referer_url = '/'
      window._czc.push(['_trackPageview', referer_url, content_url])
    }
  }
  next()
})

new Vue({
  el: '#app',
  router,
  store,
  components: {
    App
  },
  template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js